import * as React from "react";
import { Block } from "baseui/block";
import { rhetoricalRegistry } from "./rhetoricals";

type TRhetoricalProps = {
  rhetorical?: TRhetorical;
};

export function Rhetorical(props: TRhetoricalProps) {
  const { rhetorical = {}, ...restProps } = props;
  const { kind, args = {} } = rhetorical;
  const Component = React.useMemo(() => rhetoricalRegistry.getByType(kind), [kind]);
  if (!Component) {
    return null;
  }
  return (
    <Block marginTop="scale800" marginBottom="scale800">
      <Component {...restProps} {...args} />
    </Block>
  );
}

export function Rhetoricals(props) {
  const { rhetoricals = [] } = props;
  const orderedRhetoricals = React.useMemo(
    () => rhetoricals.sort((a, b) => a.order - b.order),
    [rhetoricals]
  );
  return orderedRhetoricals.map((r) => <Rhetorical key={r.id} rhetorical={r} />);
}
